module.exports = __webpack_public_path__ + "media/images/icon_eye-b018d15f30802b6a6da1bcd0539f6f82.svg";